// EditModeManager.js

class EditModeManager {
  static toggleDrawingMode(currentMode, setDrawingMode, setOtherModes) {
    const newMode = !currentMode;
    setDrawingMode(newMode);
    setOtherModes(false);
    return newMode;
  }

  static toggleEditLineMode(currentMode, setEditLineMode, setOtherModes) {
    const newMode = !currentMode;
    setEditLineMode(newMode);
    setOtherModes(false);
    return newMode;
  }

  static toggleEditLinePointMode(currentMode, setEditLinePointMode, setOtherModes) {
    const newMode = !currentMode;
    setEditLinePointMode(newMode);
    setOtherModes(false);
    return newMode;
  }

  static toggleDrawingBoundaryMode(currentMode, setDrawingBoundaryMode, setOtherModes) {
    const newMode = !currentMode;
    setDrawingBoundaryMode(newMode);
    setOtherModes(false);
    return newMode;
  }

  static toggleEditBoundaryMode(currentMode, setEditBoundaryMode, setOtherModes) {
    const newMode = !currentMode;
    setEditBoundaryMode(newMode);
    setOtherModes(false);
    return newMode;
  }

  static toggleEditBoundaryPointMode(currentMode, setEditBoundaryPointMode, setOtherModes) {
    const newMode = !currentMode;
    setEditBoundaryPointMode(newMode);
    setOtherModes(false);
    return newMode;
  }

  static disableAllModes(setAllModes) {
    setAllModes(false);
  }

  static getCurrentMode(modes) {
    for (const [mode, isActive] of Object.entries(modes)) {
      if (isActive) return mode;
    }
    return null;
  }

  static isAnyModeActive(modes) {
    return Object.values(modes).some(mode => mode);
  }
}

export default EditModeManager;